import { render, staticRenderFns } from "./product-editor-image-alt.vue?vue&type=template&id=7dd58dea&"
import script from "./product-editor-image-alt.vue?vue&type=script&lang=js&"
export * from "./product-editor-image-alt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports